import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="px-6 text-center">
        <h1 className="font-display text-earth-cream mb-4 text-8xl">404</h1>
        <p className="mb-8 text-lg text-stone-400">This trail doesn&apos;t exist.</p>
        <Link
          to="/"
          className="from-forest to-forest-dark text-earth-cream font-display hover:shadow-glow-green inline-flex items-center gap-2 rounded-lg bg-gradient-to-r px-6 py-3 text-sm tracking-wider uppercase transition-all duration-300"
        >
          Return Home
        </Link>
      </div>
    </div>
  );
}
